<template>
  <div>
    <h1>Ustawienia systemowe globalne</h1>
    <v-select v-model="canSavePassword" :items="passwordOptions" label="Możliwość zapisywania hasła w przeglądarce" />
    <v-select v-model="is_wnt" :items="enableDisable" label="Customizacja pod agencję" />
    <h2>Ustawienia w kontekście administracyjnym</h2>
    <v-select :label="$t('settings.systemSettings.accessFromNonBlockedIp')" v-model="access_from_non_blocked_ip" :items="allowDeny" />
    <v-combobox ref="whitelist" label="Whitelist" multiple v-model="ip_whitelist" chips />
    <v-combobox ref="blacklist" label="BlackList" multiple v-model="ip_blacklist" chips />
    <input type="hidden" ref="focusout" />
    <v-btn @click="saveSettings" ref="saveButton">Zapisz</v-btn>
  </div>
</template>

<script>
export default {
  name: "AdminSystemSettingsView.vue",
  data: () => ({
    canSavePassword: 3,
    passwordOptions: [
      { text: "Pozwól na zapisywanie hasła w przeglądarce", value: 2 },
      { text: "Zabroń zapisywania hasła w przeglądarce", value: 3 }
    ],
    access_from_non_blocked_ip: null,
    ip_whitelist: [],
    ip_blacklist: [],
    is_wnt: null
  }),
  methods: {
    downloadSettings() {
      this.axios.get("admin/settings/get").then(resp => {
        this.canSavePassword = parseInt(resp.data.login_password_save);
        this.access_from_non_blocked_ip = resp.data.access_from_non_blocked_ip;
        this.ip_whitelist = resp.data.ip_whitelist;
        this.ip_blacklist = resp.data.ip_blacklist;
        this.is_wnt = resp.data.is_wnt;
      });
    },
    saveSettings() {
      this.$refs.blacklist.updateSelf();
      this.$refs.whitelist.updateSelf();
      this.axios
        .post("admin/settings/save", {
          login_password_save: this.canSavePassword,
          access_from_non_blocked_ip: this.access_from_non_blocked_ip,
          ip_whitelist: this.ip_whitelist,
          ip_blacklist: this.ip_blacklist,
          is_wnt: this.is_wnt
        })
        .then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved")
          });
        });
    }
  },
  computed: {
    enableDisable() {
      return [
        {
          value: 0,
          text: this.$t("$staticData.settingsTypes.revertDefaultValue")
        },
        { value: 2, text: this.$t("global.enabled") },
        { value: 1, text: this.$t("global.disabled") }
      ];
    },
    allowDeny() {
      return [
        {
          value: 0,
          text: this.$t("$staticData.settingsTypes.revertDefaultValue")
        },
        { value: 1, text: this.$t("global.deny") },
        { value: 2, text: this.$t("global.allow") }
      ];
    }
  },
  created() {
    this.downloadSettings();
  }
};
</script>

<style scoped></style>
